// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"video_videoContainer__gjtJE","video":"video_video__0dh1y","videoTitle":"video_videoTitle__9_8Hm"};